export default __webpack_public_path__ + "static/media/project_cadefi_blur.ba4e6a9b.png";